/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module special-characters/specialcharactersmathematical
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
/**
 * A plugin that provides special characters for the "Mathematical" category.
 *
 *		ClassicEditor
 *			.create( {
 *				plugins: [ ..., SpecialCharacters, SpecialCharactersMathematical ],
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 * @extends module:core/plugin~Plugin
 */
export default class SpecialCharactersMathematical extends Plugin {
    /**
	 * @inheritDoc
	 */
    init() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get('SpecialCharacters').addItems('Mathematical', [
            {
                character: '<',
                title: t('ii')
            },
            {
                character: '>',
                title: t('ij')
            },
            {
                character: '\u2264',
                title: t('ik')
            },
            {
                character: '\u2265',
                title: t('il')
            },
            {
                character: '\u2013',
                title: t('im')
            },
            {
                character: '\u2014',
                title: t('in')
            },
            {
                character: '\xAF',
                title: t('io')
            },
            {
                character: '\u203E',
                title: t('ip')
            },
            {
                character: '\xB0',
                title: t('iq')
            },
            {
                character: '\u2212',
                title: t('ir')
            },
            {
                character: '\xB1',
                title: t('is')
            },
            {
                character: '\xF7',
                title: t('it')
            },
            {
                character: '\u2044',
                title: t('iu')
            },
            {
                character: '\xD7',
                title: t('iv')
            },
            {
                character: 'ƒ',
                title: t('iw')
            },
            {
                character: '\u222B',
                title: t('ix')
            },
            {
                character: '\u2211',
                title: t('iy')
            },
            {
                character: '\u221E',
                title: t('iz')
            },
            {
                character: '\u221A',
                title: t('ja')
            },
            {
                character: '\u223C',
                title: t('jb')
            },
            {
                character: '\u2245',
                title: t('jc')
            },
            {
                character: '\u2248',
                title: t('jd')
            },
            {
                character: '\u2260',
                title: t('je')
            },
            {
                character: '\u2261',
                title: t('jf')
            },
            {
                character: '\u2208',
                title: t('jg')
            },
            {
                character: '\u2209',
                title: t('jh')
            },
            {
                character: '\u220B',
                title: t('ji')
            },
            {
                character: '\u220F',
                title: t('jj')
            },
            {
                character: '\u2227',
                title: t('jk')
            },
            {
                character: '\u2228',
                title: t('jl')
            },
            {
                character: '\xAC',
                title: t('jm')
            },
            {
                character: '\u2229',
                title: t('jn')
            },
            {
                character: '\u222A',
                title: t('jo')
            },
            {
                character: '\u2202',
                title: t('jp')
            },
            {
                character: '\u2200',
                title: t('jq')
            },
            {
                character: '\u2203',
                title: t('jr')
            },
            {
                character: '\u2205',
                title: t('js')
            },
            {
                character: '\u2207',
                title: t('jt')
            },
            {
                character: '\u2217',
                title: t('ju')
            },
            {
                character: '\u221D',
                title: t('jv')
            },
            {
                character: '\u2220',
                title: t('jw')
            },
            {
                character: '\xBC',
                title: t('jx')
            },
            {
                character: '\xBD',
                title: t('jy')
            },
            {
                character: '\xBE',
                title: t('jz')
            }
        ]);
    }
}